<template lang="pug">
.informacoes-gerais(
    :class='{ "dados-separados": separados, small: small }',
    :style='{ justifyContent: justify }'
)
    i(v-if='iconClass', :class='fullIconClass')

    .item-detail
        h5.item-title {{ title }}

        .value
            h6.item-value(v-if='value != null && typeof value === "number"') {{ convertedUnit | numeral(formato) }} {{ unidadeMedida | lowercase }}
            h6.item-value(v-if='value != null && typeof value === "string"') {{ value }}
            h6.item-value(v-if='value == null') Sem dados
            slot
</template>

<script>
export default {
    name: 'ItemInformacoes',

    props: {
        iconClass: {
            type: String,
            required: false
        },
        icone: {
            type: String,
            required: false
        },
        title: {
            type: String,
            required: true
        },
        value: {
            type: Number | String,
            required: true
        },
        unidade: {
            type: String,
            default: ''
        },
        small: {
            type: Boolean,
            default: false
        },
        separados: {
            type: Boolean,
            default: false
        },
        formato: {
            type: String,
            default: '0 a'
        },
        justify: {
            type: String,
            default: 'center'
        }
    },

    computed: {
        convertedUnit() {
            if (
                this.unidade === 'kg' &&
                typeof this.value === 'number' &&
                this.value >= 1000
            ) {
                this.changeToTon();
                return this.value / 1000;
            }
            return this.value;
        },
        fullIconClass() {
            let classe = this.iconClass || '';
            classe += this.small ? ' small' : '';
            return classe;
        }
    },

    data() {
        return {
            unidadeMedida: this.unidade
        };
    },

    methods: {
        changeToTon() {
            this.unidadeMedida = 'ton';
        },
        assetSrc(icone) {
            return `../../../assets/${icone}`;
        }
    },

    filters: {
        lowercase: function (value) {
            if (!value) return '';
            return value.toLowerCase();
        }
    }
};
</script>

<style lang="scss" scoped>
.informacoes-gerais {
    height: 100%;
    display: flex;
    align-items: center;

    &.small {
        margin: 10px 0;
    }

    .mdi {
        @include icon-size(x-large);
        color: var(--secondary);
        margin-right: 10px;
        line-height: 52px;
    }

    .mdi.small {
        @include icon-size(medium);
        line-height: 24px;
    }

    .vgi,
    .flow {
        @include icon-size(large);
        color: var(--secondary);
        margin-right: 16px;
        line-height: 52px;
        // padding: 5px;
    }
    .element {
        @include icon-size(large);
        color: var(--secondary);
        margin-right: 16px;
        line-height: 52px;
        // padding: 5px;
    }

    .element.small {
        font-size: 22px !important;
        margin-right: 10px;
        line-height: 24px;
        // padding: 5px;
    }

    .vgi.small,
    .flow.small {
        font-size: 22px !important;
        line-height: 24px;
        margin-right: 10px;
        // padding: 0;
    }

    .item-detail {
        display: grid;
        line-height: 1.1;

        .item-title {
            color: var(--secondary-font-color);
        }

        .value {
            display: flex;
        }

        .item-value {
            font-weight: map-get($font-weight, medium);
        }

        .item-value-detail {
            padding-left: 5px;
        }
    }
}

.dados-separados {
    height: 100%;
    display: flex;
    @include border-radius($default-border-radius);
    border: 1px solid var(--default-border-color);
    background-color: var(--white);
    justify-content: left;
    padding: 0 15px;
}
</style>
